import React from 'react';
import {PageIndicator} from '../../PageIndicator/PageIndicator';
import {t} from 'i18next';
import {ActionButton, ItemsFooterWrapper} from './ItemsFooter.style';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import {TemplatePropertySettings} from '../../../models/TemplatePropertySettings';
import {isVisibleComponent} from '../../../utils/TemplateUtils';
import {
    ITEMS_FOOTER_MOBILE_NEXT_PAGE,
    ITEMS_FOOTER_MOBILE_PAGE_INDICATOR,
    ITEMS_FOOTER_MOBILE_PREVIOUS_PAGE,
    ITEMS_FOOTER_NEXT_PAGE,
    ITEMS_FOOTER_PAGE_INDICATOR,
    ITEMS_FOOTER_PREVIOUS_PAGE
} from '../../../init/ui_component_constants';
import {getFontSize} from '../../../utils';

export interface ItemsFooterProps {
    readonly templatePropertySettings: Map<string, TemplatePropertySettings>;
    readonly isMobileView: boolean;
    readonly isMobileResolution: boolean;
    readonly page: number;
    readonly pageCount: number;
    onPageChange: (page: number) => void;
}

/**
 * @name ItemsFooter
 * @description
 * Component for the footer of the item visualisation
 */
export const ItemsFooter: React.VFC<ItemsFooterProps> = (props) => {
    let fontSize = getFontSize([
        t('FOOTER_COMPONENT_PREVIOUS_PAGE'),
        t('FOOTER_COMPONENT_NEXT_PAGE')
    ], 10);

    return (
        <ItemsFooterWrapper id={generateIdentifier()}>
            {(isVisibleComponent(ITEMS_FOOTER_PREVIOUS_PAGE, props.templatePropertySettings)
                    && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ITEMS_FOOTER_MOBILE_PREVIOUS_PAGE, props.templatePropertySettings)))) &&
                <div id={generateIdentifier()}>
                    <ActionButton id={generateIdentifier()}
                                  icon='arrow-left'
                                  disabled={props.page === 1}
                                  mode='secondary'
                                  label={t('FOOTER_COMPONENT_PREVIOUS_PAGE')}
                                  title={t('FOOTER_COMPONENT_PREVIOUS_PAGE')}
                                  fontSize={fontSize}
                                  onClick={() => {
                                      props.onPageChange(props.page - 1);
                                  }}/>
                </div>
            }
            {(isVisibleComponent(ITEMS_FOOTER_PAGE_INDICATOR, props.templatePropertySettings)
                    && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ITEMS_FOOTER_MOBILE_PAGE_INDICATOR, props.templatePropertySettings)))) &&
                <PageIndicator templatePropertySettings={props.templatePropertySettings}
                               isMobileResolution={props.isMobileResolution}
                               pages={props.pageCount}
                               selected={props.page}
                               onPageSelect={props.onPageChange}/>
            }
            {(isVisibleComponent(ITEMS_FOOTER_NEXT_PAGE, props.templatePropertySettings)
                    && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ITEMS_FOOTER_MOBILE_NEXT_PAGE, props.templatePropertySettings)))) &&
                <div>
                    <ActionButton id={generateIdentifier()}
                                  icon='arrow-right'
                                  disabled={props.page >= props.pageCount}
                                  mode='secondary'
                                  label={t('FOOTER_COMPONENT_NEXT_PAGE')}
                                  title={t('FOOTER_COMPONENT_NEXT_PAGE')}
                                  fontSize={fontSize}
                                  onClick={() => props.onPageChange(props.page + 1)}/>
                </div>
            }
        </ItemsFooterWrapper>
    );
};
